export const LOAD_ONESTEP_REGISTER = "LOAD_ONESTEP_REGISTER";
export const SUCCESS_ONESTEP_REGISTER = "SUCCESS_ONESTEP_REGISTER";
export const ERROR_ONESTEP_REGISTER = "ERROR_ONESTEP_REGISTER";
export const ACTION_ONESTEP_REGISTER = 'ACTION_ONESTEP_REGISTER';
export const FORCE_STOPLOAD_ONESTEP_REGISTER = 'FORCE_STOPLOAD_ONESTEP_REGISTER';